import { render, staticRenderFns } from "./news.mixins.vue?vue&type=template&id=1e4a1dc2"
import script from "./news.mixins.vue?vue&type=script&lang=js"
export * from "./news.mixins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports